/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Link = 'Website.AdvisorToolbox.Shared.Link';
export const OnlyClubMatas = 'Website.AdvisorToolbox.Shared.OnlyClubMatas';
export const ClubMatas = 'Website.AdvisorToolbox.Shared.ClubMatas';
